import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import API from '../../common/services/api.config.json';
import { ApiService } from 'app/modules/common/services/api.service';


@Injectable({
  providedIn: 'root'
})
export class CostReportService {

  constructor(
    private apiService: ApiService,
    ) { }


  GetConvenioList(trabajadorId:any): Observable<RestResponse> {
    let url = `${API.EmployeeCost.getConvenioList}`;
    url = url.replace('{trabajadorId}',trabajadorId);
    return this.apiService.get(url);
  }
  GetCostReport(values: any): Observable<RestResponse> {
    let url = `${API.EmployeeCost.generateCostReport}`;
    return this.apiService.post(url, values);
}
}
